var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagCn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V92.42H139.13V0Z",
    fill: "#D01317"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9501 13.24L30.4501 25.02L41.8401 25L32.6101 32.25L36.1501 44.01L26.9501 36.72L17.7401 44.01L21.2901 32.25L12.0601 25L23.4501 25.02L26.9501 13.24Z",
    fill: "#F3DE3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.46 37.48L62.38 40.58L65.38 40.57L62.95 42.48L63.88 45.58L61.46 43.66L59.04 45.58L59.97 42.48L57.54 40.57L60.54 40.58L61.46 37.48Z",
    fill: "#F3DE3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7701 21.36L62 23.54L64.59 21.91L63.37 24.88L65.6 27.06L62.62 26.71L61.4001 29.69L60.78 26.5L57.8 26.17L60.4001 24.54L59.7701 21.36Z",
    fill: "#F3DE3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.08 8.76001L53.16 12.02L56.04 12.93L53.21 14.02L53.3 17.28L51.48 14.69L48.65 15.79L50.35 13.11L48.52 10.53L51.39 11.45L53.08 8.76001Z",
    fill: "#F3DE3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0899 47.96L53.8099 51.2L56.5599 52.49L53.6399 53.2L53.3599 56.44L51.8399 53.64L48.9099 54.36L50.8999 51.92L49.3599 49.12L52.1199 50.41L54.0899 47.96Z",
    fill: "#F3DE3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCn);
export default __webpack_public_path__ + "static/media/Flag_CN.490cede5bdb29bdfa35d8d176c7f4929.svg";
export { ForwardRef as ReactComponent };